<template>
    <div class="requests__list">
        <div class="requests__list_header">
            <view-actions
                :title="'Requests'"
                :cancel-button-active="false"
                :submit-button-active="false"
            />
        </div>
        <div class="requests__list_main">
            <component-list
                :component-table="RequestsListTable"
                :component-table-name="'requests'"
                :empty-state-title="'Enrolment requests will appear here.'"
                :filter-search-queryable="true"
                :item-name="['request', 'requests']"
                :get-items-getter="'getEbsRequests'"
                :get-items-dispatch="'ebsRequestsGet'"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentList from '@/components/default/shared/ComponentList'
import RequestsListTable from '@/components/ebs/requests/list/RequestsListTable'
import { User } from '@/User'

export default {
  name: 'requests-list',
  components: { ComponentList, ViewActions },
  data () {
    return {
      user: new User(),
      RequestsListTable
    }
  },
  methods: {
    createrequests () {
      this.$router.push({ name: 'ebs-requests-add' })
    }
  }
}
</script>
